export const features = [
  {
    title: 'Digital Process Automation',
    description: 'Publish service request offers to designated private list of advisors or publish offers to recommended public advisors.',
  },
  {
    title: 'Contract Verification AI Agents',
    description: `AI agent assisted contract preparation based on organization's template.`,
  },
  {
    title: 'Advisor Co-pilot',
    description: 'Leverage AI advisory agents to summarize shared notes and draft specific document types.',
  },
  {
    title: 'Compliance & Audit',
    description: 'Policy controls, sensitive data guardrails, audit trails to support regulatory obligations.',
  },
  {
    title: 'Integrations',
    description: 'Securely collaborate with multiple expert advisors to prepare Agreements and digital sign documents.',
  },
  {
    title: 'Security by Design',
    description: 'Enterprise SSO, role‑based access, and data residency options for sensitive client information.',
  },
];

export const industries = [
  'Private banks and multi‑family offices',
  'RIAs, portfolio managers, and trust companies',
  'Tax, insurance, succession, and estate planning professionals',
];